import { LE_CONTRACTED_HOTEL_TYPES, OFFER_TYPE_HOTEL } from 'constants/offer'
import { DESTINATIONS, EUROPE_REGIONS } from 'constants/config/region'
import { MAX_CAROUSEL_ITEM_COUNT } from './common/constants'

/** European storefronts that can show the local-destination offer carousel below Trending Destinations. */
export const LOCAL_DESTINATION_OFFER_CAROUSEL_REGIONS = EUROPE_REGIONS

/**
 * Synthetic chip value for the default multi-destination stream search.
 * Not a place id — pass `isLocalDestinationOfferAllFilter` as
 * `shouldKeepBaseDestinationFilters` so OfferCardCarouselSection keeps the base multi-place filters.
 */
export const LOCAL_DESTINATION_OFFER_ALL_FILTER_VALUE = 'all'
export const LOCAL_DESTINATION_OFFER_EUROPE_DESTINATION_ID = DESTINATIONS.europe.destinationId

/** English analytics destination name for the Europe All stream. */
export const LOCAL_DESTINATION_OFFER_EUROPE_ANALYTICS_DESTINATION_NAME = 'Europe'

/**
 * Stop waiting for unresolved eligibility checks and show or hide based on resolved destinations.
 *
 * When this elapses we freeze the current eligible country set for chips (including empty).
 * Late flash-search responses after freeze do not add or insert chips, which avoids a layout
 * shift after the user has already scrolled past the module.
 */
export const LOCAL_DESTINATION_OFFER_ELIGIBILITY_TIMEOUT_MS = 10_000
export const LOCAL_DESTINATION_OFFER_MINIMUM_FLASH_OFFER_COUNT = 2

/**
 * Cards in the row: Flash + always-on (LE contracted hotels). Country *chips* are gated
 * separately on Flash-only inventory via `buildLocalDestinationFlashOfferListFilters`.
 * That split is intentional — a pill means “this country has Flash depth”; the track can
 * still fill with always-on once the user is in that country (or on All).
 */
export const LOCAL_DESTINATION_OFFER_CAROUSEL_FILTERS: App.OfferListFilters = {
  offerTypes: LE_CONTRACTED_HOTEL_TYPES,
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
}

export function isLocalDestinationOfferAllFilter(value: string | undefined): boolean {
  return value === LOCAL_DESTINATION_OFFER_ALL_FILTER_VALUE
}

/**
 * Default "All" list: hotel stream search across Europe.
 */
export function buildLocalDestinationOfferAllFilters(): App.OfferListFilters {
  return {
    ...LOCAL_DESTINATION_OFFER_CAROUSEL_FILTERS,
    destinationId: LOCAL_DESTINATION_OFFER_EUROPE_DESTINATION_ID,
    isStream: true,
  }
}

/** Single-destination chip list: light-search default MPV for one place */
export function buildLocalDestinationOfferListFilters(destinationId: string): App.OfferListFilters {
  return {
    ...LOCAL_DESTINATION_OFFER_CAROUSEL_FILTERS,
    destinationId,
  }
}

/** Chip eligibility only: Flash hotels, excluding tactical/always-on. Display lists still use contracted types. */
export function buildLocalDestinationFlashOfferListFilters(destinationId: string): App.OfferListFilters {
  return {
    ...LOCAL_DESTINATION_OFFER_CAROUSEL_FILTERS,
    offerTypes: [OFFER_TYPE_HOTEL],
    destinationId,
    limit: LOCAL_DESTINATION_OFFER_MINIMUM_FLASH_OFFER_COUNT,
  }
}
